
<div class="right-side p-5">
  <form [formGroup]="viewMSMEParticipantForm">
    <h2>Enrolled MSME Details</h2>
    <div class="row section">

      <div class="text-end">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
      </div>

      <!--SEARCH-->
      <div class="col-lg-7 col-sm-12">
        <div class="search-container">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="search" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(viewMSMEParticipantForm.get('search')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>
        </div>
      </div>



      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource1" class="table table-striped table-bordered table-hover" matSort matSortActive="eventDate" matSortDirection="desc" matSortDisableClear>

          <!-- Sr.No Column -->
          <ng-container matColumnDef="serialNumber">
            <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
            <td mat-cell *matCellDef="let item"> {{ item.SerialNumber }} </td>
          </ng-container>

          <!-- EventId Column -->
          <ng-container matColumnDef="eventId">
            <th mat-header-cell *matHeaderCellDef> Event ID </th>
            <td mat-cell *matCellDef="let item"> {{ item.EventId }} </td>
          </ng-container>

          <!-- Udyam Number Column -->
          <ng-container matColumnDef="udyamNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Udyam Number </th>
            <td mat-cell *matCellDef="let item"> {{ item.UdyamNumber }} </td>
          </ng-container>

          <!-- Name of Enterprise Column -->
          <ng-container matColumnDef="nameOfEnterprise">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name of Enterprise </th>
            <td mat-cell *matCellDef="let item"> {{ item.NameOfEnterprise }} </td>
          </ng-container>

          <!-- User Name Column -->
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let item"> {{ item.UserName }} </td>
          </ng-container>

          <!-- Event Name Column -->
          <ng-container matColumnDef="eventName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Event Name </th>
            <td mat-cell *matCellDef="let item"> {{ item.eventName }} </td>
          </ng-container>

          <!-- User Mobile Number Column -->
          <ng-container matColumnDef="userMobileNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile Number Registered with Udyam </th>
            <td mat-cell *matCellDef="let item"> {{ item.UserMobileNo }} </td>
          </ng-container>

          <!-- User Email Column -->
          <ng-container matColumnDef="userEmail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let item"> {{ item.UserEmail }} </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let item"> {{ item.Status }} </td>
          </ng-container>

          <!-- Table Header and Rows -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

  

      <mat-paginator #paginator
                     class="demo-paginator"
                     (page)="onPageChange($event)"
                     [length]="length"
                     [pageSize]="pageSize"
                     [disabled]="disabled"
                     [showFirstLastButtons]="showFirstLastButtons"
                     [pageSizeOptions]="pageSizeOptions"
                     [hidePageSize]="hidePageSize"
                     [pageIndex]="pageIndex"
                     aria-label="Select page">
      </mat-paginator>

    </div>
  </form>
</div>
